<template>
  <b-modal
    :visible="visible"
    :title="mode === 'create' ? $t('roleMatrix_createRole') : $t('roleMatrix_editRole')"
    @change="$emit('update:visible', $event)"
    @shown="name = initialName"
  >
    <b-form-group :label="$t('name')" label-for="role-dialog-name">
      <b-form-input id="role-dialog-name" v-model="name" @keydown.enter="submit" />
    </b-form-group>

    <template #modal-footer>
      <div class="role-dialog__footer" :class="{ 'role-dialog__footer--split': mode === 'rename' }">
        <b-button v-if="mode === 'rename'" variant="danger" @click="remove">
          {{ $t('delete') }}
        </b-button>
        <b-button variant="bg" :disabled="!trimmedName" @click="submit">
          {{ mode === 'create' ? $t('create') : $t('save') }}
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'RoleDialog',
  props: {
    visible: { type: Boolean, default: false },
    mode: { type: String, default: 'create' },
    initialName: { type: String, default: '' },
  },
  data() {
    return { name: '' };
  },
  computed: {
    trimmedName() {
      return this.name.trim();
    },
  },
  methods: {
    submit() {
      if (!this.trimmedName) {
        return;
      }
      this.$emit('submit', this.trimmedName);
      this.$emit('update:visible', false);
    },
    remove() {
      this.$emit('delete');
      this.$emit('update:visible', false);
    },
  },
};
</script>

<style lang="scss" scoped>
.role-dialog__footer {
  display: flex;
  justify-content: flex-end;
  width: 100%;

  &--split {
    justify-content: space-between;
  }
}
</style>
